import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero has-background-primary pb-6" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "block pt-6" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = {
  class: "has-text-primary has-text-centered is-size-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "has-text-white has-text-centered is-size-5 pt-4",
    style: {"font-family":"Calibri","font-weight":"bold"}
  }, " REDUCIMOS LOS COSTOS EFECTIVAMENTE ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "has-text-white has-text-justified is-size-6 pt-4",
    style: {"font-family":"Calibri","font-weight":"bold"}
  }, " Por experiencia sabemos que los costos de mantenimiento, los gastos en insumos y las mermas del producto son costos que impactan fuerte la rentabilidad de la empresa; sí o sí la tecnología que integramos a la línea genera una diferencia en costos entre el antes vs después. ")
], -1)
const _hoisted_9 = { class: "column" }
const _hoisted_10 = {
  class: "has-text-primary has-text-centered is-size-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "has-text-white has-text-centered is-size-5 pt-4",
    style: {"font-family":"Calibri","font-weight":"bold"}
  }, " ACORTAMOS TIEMPOS DE PRODUCCIÓN ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "has-text-white has-text-justified is-size-6 pt-4",
    style: {"font-family":"Calibri","font-weight":"bold"}
  }, " Somos buenos detectando los cuellos de botella y aún más para dar solución con tecnología. Entre nuestros logros están: aumentar la capacidad de producción, sin sacrificar la seguridad del operador y la calidad del producto, y automatizar líneas completas de producción en pharma y alimentos. ")
], -1)
const _hoisted_13 = { class: "column" }
const _hoisted_14 = {
  class: "has-text-primary has-text-centered is-size-5",
  style: {"font-family":"Calibri","font-weight":"bold"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "has-text-white has-text-centered is-size-5 pt-4",
    style: {"font-family":"Calibri","font-weight":"bold"}
  }, " AUMENTAMOS LA SEGURIDAD ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "has-text-white has-text-justified is-size-6 pt-4",
    style: {"font-family":"Calibri","font-weight":"bold"}
  }, " Nos tomamos muy en serio la seguridad del producto y del operador. Nuestros equipos cuentan con normas y certificaciones internacionales que los catalogan como tecnología segura y confiable, además en todo momento contamos con el servicio de asesoría para entrenar a los técnicos y obtener el máximo provecho de los equipos. ")
], -1)

import SvgIcon from "@jamescoyle/vue-icon";
import { useWindowSize } from "vue-window-size";
import { mdiCheckboxMarkedCircle } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'DifferenceComponent',
  setup(__props) {

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-centered has-text-white pt-6", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, " ¿POR QUÉ HACEMOS LA DIFERENCIA? ", 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["columns is-variable", _unref(width) < 768 ? '' : 'is-8'])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_6, [
                  _createVNode(_unref(SvgIcon), {
                    type: "mdi",
                    path: _unref(mdiCheckboxMarkedCircle),
                    style: {"color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
                  }, null, 8, ["path"])
                ])
              ]),
              _hoisted_7,
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_10, [
                  _createVNode(_unref(SvgIcon), {
                    type: "mdi",
                    path: _unref(mdiCheckboxMarkedCircle),
                    style: {"color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
                  }, null, 8, ["path"])
                ])
              ]),
              _hoisted_11,
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_14, [
                  _createVNode(_unref(SvgIcon), {
                    type: "mdi",
                    path: _unref(mdiCheckboxMarkedCircle),
                    style: {"color":"#38ac61","vertical-align":"text-bottom","width":"110px","height":"110px","border-radius":"50%"}
                  }, null, 8, ["path"])
                ])
              ]),
              _hoisted_15,
              _hoisted_16
            ])
          ], 2)
        ])
      ])
    ])
  ]))
}
}

})